import React from 'react';

const AddressesPage = () => {
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="font-serif text-4xl mb-4">Addresses</h1>
        <p className="text-gray-600">Coming soon...</p>
      </div>
    </div>
  );
};

export default AddressesPage;
